// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})


// Fermeture sticky au scroll
window.addEventListener('scroll', function() {
    let stickyAccount = document.querySelector('.sticky__link--visible');
    if (window.scrollY > 1) {
        stickyAccount.classList.add('hidden');
    } else {
        stickyAccount.classList.remove('hidden');
    }
});
